export default `uniform vec3 color;

void main() {
    vec2 p = gl_PointCoord.xy * 2.0 - vec2(1.0); 
    
    vec2 v0 = vec2(0.0, 1.0);
    vec2 v1 = vec2(-1.0, -1.0);
    vec2 v2 = vec2(1.0, -1.0);

    
    vec2 e0 = v1 - v0;
    vec2 e1 = v2 - v1;
    vec2 e2 = v0 - v2;

    
    vec2 vp0 = p - v0;
    vec2 vp1 = p - v1;
    vec2 vp2 = p - v2;

    
    float c0 = cross(vec3(e0, 0.0), vec3(vp0, 0.0)).z;
    float c1 = cross(vec3(e1, 0.0), vec3(vp1, 0.0)).z;
    float c2 = cross(vec3(e2, 0.0), vec3(vp2, 0.0)).z;

    
    float inside = step(0.0, c0) * step(0.0, c1) * step(0.0, c2);

    
    gl_FragColor = vec4(color, inside);
}`